import { computed, defineComponent, ref } from 'vue';
import { useSweetAlert } from '@/composables/sweetalert';
import { useStore } from 'vuex';
import { ProcureAction, ProcureGetter } from '@/store/procure/procure.module';
import { Procure, ProcureAttachment } from '@/store/procure/procure.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'ProjectProcureAttachmentModalComponent',
  components: {
    BaseModalComponent
  },
  props: {
    projectId: {
      type: Number,
    }
  },
  emits: [
    'upload',
  ],
  setup: (props, context) => {
    const swal = useSweetAlert();
    const store = useStore();
    const procure = computed<Procure>(() => store.getters[ProcureGetter.GET]);
    const attachments = computed<ProcureAttachment[]>(() => (procure.value) ? procure.value?.attachments.filter(m => m.attachmentType.id === 1) : []);
    const isLoading = computed<boolean>(() => store.getters[ProcureGetter.STATUS] === 'init' || store.getters[ProcureGetter.STATUS] === 'loading');
    const attachmentModal = ref<InstanceType<typeof BaseModalComponent>>();

    // show modal
    const show = () => {
      attachmentModal.value?.show();
    };

    // hide modal
    const hide = () => {
      attachmentModal.value?.hide();
    };

    // upload click
    const uploadClick = () => {
      context.emit('upload');
    };

    // delete click
    const deleleClick = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(ProcureAction.REMOVE_ATTACHMENTS, {
              projectId: props.projectId,
              attachmentIds: [id],
            });
          }
        });
    };

    return {
      attachments,
      attachmentModal,
      isLoading,
      show,
      hide,
      uploadClick,
      deleleClick,
    };
  },
});
